import { OpenAPI as TempusBackend } from '@/modules/api';
import { OpenAPI as Photon } from '@/modules/api-photon';

TempusBackend.BASE = import.meta.env.VITE_API_URL || `${import.meta.env.VITE_API_ORIGIN}/api`;
Photon.BASE = import.meta.env.VITE_GEOCODING_URL || `${import.meta.env.VITE_API_ORIGIN}/geocoding`;
